"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CatSport32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16 4C9.374 4 4 9.374 4 16s5.374 12 12 12 12-5.374 12-12S22.626 4 16 4zm-1.633 1.057c-.095 0 .386-.095.766-.095h.862c4.032 0 7.487 2.113 9.406 5.279.19.29.481.862.481.862-3.361-2.113-7.392-3.17-11.519-2.589-.09-1.152-.09-2.304.005-3.456zM8.703 7.746a4.9 4.9 0 01.671-.576 11.793 11.793 0 013.456-1.728c.29-.095.671-.19.576-.19-.29 3.265.29 6.721 2.018 9.791-.962 1.633-2.113 2.975-3.456 4.032A15.926 15.926 0 018.703 7.746s-.095 0 0 0zM6.689 21.95c0-.095-.386-.671-.576-1.057-.771-1.438-1.152-3.165-1.152-4.893 0-2.494.766-4.703 2.209-6.526.19-.386.576-.766.481-.671a17.2 17.2 0 003.551 10.943c-1.442.957-2.88 1.728-4.513 2.204zm3.837 3.651c-1.057-.671-2.113-1.442-2.88-2.399-.19-.19-.386-.386-.29-.386 3.651-1.247 6.821-3.741 8.93-7.297 1.823 0 3.646.386 5.279.962-1.918 4.703-5.95 8.063-10.463 9.311.1.19-.286 0-.576-.19zm15.936-6.145c0 .095-.095.29-.19.481-1.633 4.127-5.569 7.102-10.272 7.102-1.152 0-2.304-.19-3.361-.481-.095 0-.19-.095-.19-.095a17.22 17.22 0 009.982-9.601c1.538.676 2.88 1.538 4.032 2.594zm.291-.962a16.955 16.955 0 00-10.467-3.932c-.862-1.633-1.537-3.361-1.823-5.088a16.306 16.306 0 0112.095 3.265c-.095-.19.095.19.19.576.19.862.29 1.728.29 2.689 0 .576 0 1.152-.095 1.633-.095.381-.19.762-.19.857z" }))); };
var StyledCatSport32 = styled_components_1.default(CatSport32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatSport32;
var templateObject_1;
//# sourceMappingURL=CatSport32.js.map